import { useContext } from 'react';
import { prop } from 'ramda';
import { compose, withProps } from 'recompose';
import Category from '../../common/GamesCategory';
import { CATEGORY_TYPE } from '../../common/GamesCategory/constants';
import { DISPLAY_MODE, GAME_SIZES } from '../../common/GamesView/constants';
import { useDeviceSelector } from 'js/store/hooks';
import { CategoryContext } from '../context';
import Game from './GameItem';

export const SLIDER_OPTIONS = {
    animation: {
        type: 'monoSlider'
    },
    controls: {
        arrows: { enabled: true },
        bullets: { enabled: false },
        buttons: { enabled: false }
    }
};

export default compose(
    withProps(
        ({ cid }) => {
            const isDesktop = useDeviceSelector(prop('isDesktop'));
            const { expandedCategory, setExpandedCategory } = useContext(CategoryContext);
            const displayMode = isDesktop
                ? expandedCategory === cid && DISPLAY_MODE.GRID || DISPLAY_MODE.PAGING
                : DISPLAY_MODE.SLIDER;
            const gameSize = isDesktop ? GAME_SIZES.MEDIUM : GAME_SIZES.SMALL;
            const type = isDesktop ? null : CATEGORY_TYPE.TAB;
            const showTitle = false;
            return {
                isDesktop,
                expandedCategory,
                setExpandedCategory,
                displayMode,
                gameSize,
                type,
                Game,
                showTitle,
                showViewMore: true,
                sliderOptions: SLIDER_OPTIONS
            };
        }
    )
)(Category);
